import {
    SIDE_MENU_OPEN,
    SIDE_MENU_CLOSE,
} from '../actions/actionTypes/menu-action-types';

const initialState = {
    open: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SIDE_MENU_OPEN:
            return {
                ...state,
                open: true,
            };
        case SIDE_MENU_CLOSE:
            return {
                ...state,
                profiles: [],
                open: false,
            };
        default:
            return state;
    }
};
